import React from 'react'
import { useTranslation } from 'react-i18next';
import i18n from '../../../language/i18n';
import { normalizeLang } from '../../../utils/localeDataLoader';
import { useIntroduceVisionQuery } from 'hooks';

function IntroduceVision({ showTitle = true }) {
    useTranslation();
    const currentLang = normalizeLang(i18n.language);
    const { data: visionData, isLoading: loading, error } = useIntroduceVisionQuery(currentLang);


    if (loading) {
        return <div>Loading...</div>;
    }

    if (error) {
        return <div style={{ color: 'red', textAlign: 'center', padding: '20px' }}>Không thể tải dữ liệu. Vui lòng thử lại sau.</div>;
    }

    if (!visionData) {
        return <div>Không có dữ liệu.</div>;
    }

    return (
        <div className='IntroduceVision'>
            {showTitle && (
                <p style={{ color: '#4db748', fontWeight: '600', margin: "10px 0", fontSize: "2rem", textAlign: "center" }}>
                    {visionData.title}
                </p>
            )}
            <div className='IntroduceVision-content'>
                {visionData.description && (
                    <div
                        className='IntroduceVision-content-left vision-description quill-content'
                        dangerouslySetInnerHTML={{ __html: visionData.description }}
                    />
                )}
                <div className='IntroduceVision-content-visual'>
                    <span className='IntroduceVision-content-orbit' aria-hidden="true" />
                    <img className='IntroduceVision-content-img' src={visionData.image} alt="vision logo" />
                </div>
            </div>
        </div>
    )
}

export default IntroduceVision
